export default "__VITE_ASSET__jds2VS6e__$_?no-inline__"